var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "087---Customer-Service",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50 24v20h-4c-1.1032019-.0032948-1.9967052-.8967981-2-2v-16c.0032948-1.1032019.8967981-1.9967052 2-2z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 28v12c0 2.209139-1.790861 4-4 4h-4v-20h4c2.209139 0 4 1.790861 4 4z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m25 52h19c3.3137085 0 6-2.6862915 6-6v-2h4v2c-.0088096 5.5191943-4.4808057 9.9911904-10 10h-19z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#35495e",
    height: 8,
    rx: 2,
    width: 12,
    x: 13,
    y: 50
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10.69 14c3.5694197-6.18612942 10.1679449-9.99810238 17.31-10h2c11.0411252.0110246 19.9889754 8.9588748 20 20h4c-.0176281-13.2475253-10.7524747-23.98237187-24-24h-2c-9.3800032.00766076-17.8973389 5.47500141-21.81 14z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 14h-30c-2.76142375 0-5 2.2385763-5 5v20c0 1.3260824.5267842 2.597852 1.46446609 3.5355339.9376819.9376819 2.20945146 1.4644661 3.53553391 1.4644661v6l8-6h22c1.3260824 0 2.597852-.5267842 3.5355339-1.4644661s1.4644661-2.2094515 1.4644661-3.5355339v-20c0-1.3260824-.5267842-2.597852-1.4644661-3.5355339s-2.2094515-1.4644661-3.5355339-1.4644661z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e57e25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m24 24h-19c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h19c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 24h-7c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h7c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 30h-30c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h30c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m18 36h-13c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h13c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.fe37e0e1e2aefd7e67fdc1049a3d8424.svg";
export { ForwardRef as ReactComponent };